import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { TankService } from 'src/app/services/tank.service';
import { UserService } from 'src/app/services/user.service';
import { User } from 'src/app/shared/models/User';

@Component({
  selector: 'app-list-user-page',
  templateUrl: './list-user-page.component.html',
  styleUrls: ['./list-user-page.component.css']
})
export class ListUserPageComponent implements OnInit {

  users: User[] = [];
  tankName: string;
  tankId: Number;

  constructor(private userService: UserService, private tankService: TankService) {
    /*let usersObservable: Observable<User[]>
    usersObservable = userService.getAll();
    usersObservable.subscribe((serverUsers) => {
      this.users = serverUsers;
    })*/
  }

  ngOnInit() {
    this.tankService.getCurrentTank().subscribe((tank) => {
      if (tank) {
        this.tankName = tank.name;
        this.tankId = tank.id;
        this.listUsers();
      }
    });

  }

  listUsers() {
    this.userService.getUsersByTank(this.tankId).subscribe(data => {
      console.log("lista de usuarios: ", data);
      this.users = data;
    }, error => {
      console.log(error);
    })
  }

  deleteUser(id: any) {
    if (this.userService.deleteUser(id).subscribe(data => {
      this.listUsers();
    }, error => {
      console.log(error);
    })) {
      return;
    }
  }
}
